import * as Styled from "./CRM.styles";

import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";

import type { ColumnsType } from "antd/lib/table";
import type { CrmConfigItem } from "context/CRMContext"; // adjust type as per your context
import { Switch } from "antd";
import isDifferent from "utilities/isDifferent";
import { useCRM } from "context/CRMContext"; // assuming similar to useCheckMatch
import { useLocation } from "context/LocationContext";

function CRM() {
  const [save, setSave] = useState(false);
  const {
    crmData,
    initialCrmData,
    isCrmSaving,
    updateCrmData,
    updateCrmState,
    cancelChanges,
  } = useCRM();

  const { locationDetails } = useLocation();
  
  useEffect(() => {
    if (isDifferent(initialCrmData, crmData)) {
      setSave(true);
    } else {
      setSave(false);
    }
  }, [crmData, initialCrmData]);
  
  const handleToggle = useCallback((key: string, enabled: boolean) => {
    updateCrmState(key, { enabled });
  }, [updateCrmState]);

  const handleSave = useCallback(() => {
    updateCrmData();
    setSave(false);
  }, [updateCrmData]);
  const handleCancel = useCallback(() => {
    cancelChanges();
    setSave(false);
  }, [cancelChanges]);
  const columns: ColumnsType<CrmConfigItem> = [
    {
      title: "CRM",
      dataIndex: "name",
      key: "name",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "CRM Enabled",
      dataIndex: "enabled",
      key: "enabled",
      render: (_text: boolean, record: CrmConfigItem) => (
          <Styled.SwitchContainer>
            <Switch
              checked={record.enabled}
              onChange={(checked) => handleToggle(record.name, checked)}
              disabled={isCrmSaving}
            />
          </Styled.SwitchContainer>
      ),
    },
  ];
  return (
    <>
      <Styled.ButtonsRow>
        <Styled.Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          disabled={!save || isCrmSaving}
          loading={isCrmSaving}
        >
            Save Changes
        </Styled.Button>
        <Styled.Button
          type="default"
          icon={<CloseOutlined />}
          onClick={handleCancel}
          disabled={!save || isCrmSaving}
        >
            Cancel
        </Styled.Button>
      </Styled.ButtonsRow>
      <Styled.Table<any>
        key={locationDetails?.locationId}
        columns={columns}
        dataSource={crmData}
        pagination={{ pageSize: 10, hideOnSinglePage: true }}
        rowKey="name"
        style={{ marginBottom: "32px" }}
      />
    </>
  );
}
export default CRM;
